/**
 * Application Constants
 * These values are loaded from environment variables at build time
 */

// Application URLs
export const APP_URL = import.meta.env.VITE_APP_URL || 'http://localhost:5173';
export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5001';

// File Upload Limits (in bytes)
export const MAX_VIDEO_SIZE = parseInt(import.meta.env.VITE_MAX_VIDEO_SIZE || '104857600'); // 100MB default
export const MAX_IMAGE_SIZE = parseInt(import.meta.env.VITE_MAX_IMAGE_SIZE || '5242880'); // 5MB default
export const MAX_REEL_DURATION = parseInt(import.meta.env.VITE_MAX_REEL_DURATION || '120'); // 120 seconds default
export const MIN_REEL_DURATION = parseInt(import.meta.env.VITE_MIN_REEL_DURATION || '10'); // 10 seconds default

// UI Constants
export const MAX_VIDEO_DISPLAY_HEIGHT = '400px';
export const MAX_REEL_DISPLAY_HEIGHT = '300px';
export const INBOX_MESSAGES_HEIGHT = 'calc(100vh - 200px)';

// Pricing — defaults used when creating new offerings; actual prices are stored per-offering in Firestore
export const DEFAULT_SHOT_CONSULT_PRICE = 3500;  // $35 in cents
export const DEFAULT_LESSON_PRICE = 5000;         // $50 in cents
export const DEFAULT_BUNDLE_PRICE = 20000;        // $200 in cents (4-lesson package)

// Lesson Lifecycle Timing (in hours)
// Set to -1 to disable the corresponding limit/transition.
export const LESSON_ACCEPTANCE_DEADLINE_HOURS: number = 24; // -1 = no deadline
export const LESSON_AUTO_COMPLETE_HOURS: number = 72; // -1 = never auto-complete

// Pagination & Limits
export const MESSAGES_PAGE_SIZE = parseInt(import.meta.env.VITE_MESSAGES_PAGE_SIZE || '50');
export const REELS_PAGE_SIZE = parseInt(import.meta.env.VITE_REELS_PAGE_SIZE || '20');

// Feature Flags
export const ENABLE_NOTIFICATIONS = import.meta.env.VITE_ENABLE_NOTIFICATIONS !== 'false';
export const ENABLE_ANALYTICS = import.meta.env.VITE_ENABLE_ANALYTICS !== 'false';
export const USE_EMULATORS = import.meta.env.VITE_USE_EMULATORS === 'true';

// Helper functions
export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return bytes + ' B';
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(2) + ' KB';
  if (bytes < 1024 * 1024 * 1024) return (bytes / (1024 * 1024)).toFixed(2) + ' MB';
  return (bytes / (1024 * 1024 * 1024)).toFixed(2) + ' GB';
}

export function getMaxVideoSizeLabel(): string {
  return formatFileSize(MAX_VIDEO_SIZE);
}

export function getMaxImageSizeLabel(): string {
  return formatFileSize(MAX_IMAGE_SIZE);
}
